import React from 'react'
import { Link } from "react-router-dom";
import { FaGreaterThan } from 'react-icons/fa'

import './styles.css'

// define a barra de navegação do website
// parametros: lista de objetos contendo informações
// para navegação: link, nome
const NavigationBar = ({navegation}) => {

    const amountLinks = navegation.length

    return (
        <div className="nav-bar-container">

            {navegation.map((item, index) => (
                <div key={item.nome}>
                    <Link className="nav-bar-link" to={item.link}>{item.nome}</Link>
                    {index < amountLinks - 1 ? <FaGreaterThan className="nav-bar-icon" /> : null }
                </div>
            ))}
        </div>
    );
}

export default NavigationBar;